<div class="grid-calibration-wrapper">
    <div class="grid-calibration">
        <div #point (pointerover)="onPointOver($event)" class="pulse dot "></div>
    </div>
    <!--    -->
    <!--  <div class="calibration-row" *ngFor="let row of rows">-->
    <!--    <div class="calibration-col" *ngFor="let col of cols">-->
    <!--        <div *ngIf="currentPoint.row === row && currentPoint.col === col"-->
    <!--             (pointerover)="onPointOver($event)" class="pulse dot "></div>-->
    <!--    </div>-->
    <!--  </div>-->
</div>
